import { Group } from '@mantine/core';
import { ChartType } from '../../../../store/financials-store/financials-store.type';
import { newCOLORS } from '../../../../styles/colors';
import { Button } from '../../../../ui-library/button/button';
import { Icon } from '../../../../ui-library/icon/icon';

function ChartDisplayTypeButtonSet({
  onSetLineChart,
  onSetBarChart,
  selectedChartType,
}: { onSetLineChart: () => void; onSetBarChart: () => void; selectedChartType: ChartType }) {
  return (
    <Group mb={12} justify="space-between">
      <Group>
        <StyledButton
          label="Line Chart"
          iconName="stacked_line_chart"
          onClick={onSetLineChart}
          selected={selectedChartType === ChartType.Line}
        />
        <StyledButton
          label="Bar Chart"
          iconName="bar_chart"
          onClick={onSetBarChart}
          selected={selectedChartType === ChartType.Bar}
        />
      </Group>
      <StyledButton label="Export" iconName="download" onClick={() => {}} selected={true} />
    </Group>
  );
}

function StyledButton({
  label,
  iconName,
  onClick,
  selected,
}: { label: string; iconName: string; onClick: () => void; selected: boolean }) {
  return (
    <Button
      variant={selected ? 'secondary' : 'outline'}
      radius="xl"
      size="sm"
      leftSection={
        <Icon
          name={iconName}
          color={selected ? newCOLORS.white : newCOLORS.gray}
          size={16}
          style={{ cursor: 'pointer' }}
        />
      }
      onClick={onClick}
    >
      {label}
    </Button>
  );
}

export { ChartDisplayTypeButtonSet };
